import { BaseDto } from "../common/baseDto";

export interface SysCodeDto extends BaseDto {
    /** 검색하려는 메이저코드 (예: SYSTEM, DEV_STS 등) */
    majorCd: string;
    
    /** 선택된 상세코드 (드롭다운에서 선택될 minorCd 값) */
    minorCd: string;
    
    /** 코드명 (옵션으로 사용 가능) */
    codeNm: string;
	sysFlg?: string;
	dispSeq: number;
	ref01: string;
	ref02: string;
	ref03: string;
	ref04: string;
	ref05: string;
	ref06: string;
	ref07: string;
	ref08: string;
	ref09: string;
	ref10: string;
	remark: string;

	inserted: boolean;
	isModified: boolean;
	originalData?: SysCodeDto;
} 

export const defaultSysCodeDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	majorCd: ``,
	minorCd: ``,
	codeNm: ``,
	sysFlg: "Y",
	dispSeq: 0,
	ref01: ``,
	ref02: ``,
	ref03: ``,
	ref04: ``,
	ref05: ``,
	ref06: ``,
	ref07: ``,
	ref08: ``,
	ref09: ``,
	ref10: ``,
	remark: ``,
	insertDt: new Date(),
	insertUser: ``,
	insertForm: ``,
	updateDt: new Date(),
	updateUser: ``,
	updateForm: ``,

	inserted: false,
	isModified: false,
	originalData: undefined,
}


export const defaultSysCode_Modal: SysCodeDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	
	majorCd: ``,
	minorCd: ``,
	codeNm: ``,
	sysFlg: "Y",
	dispSeq: 0,
	ref01: ``,
	ref02: ``,
	ref03: ``,
	ref04: ``,
	ref05: ``,
	ref06: ``,
	ref07: ``,
	ref08: ``,
	ref09: ``,
	ref10: ``,
	remark: ``,
	insertDt: new Date(),
	insertUser: ``,
	insertForm: ``,
	updateDt: new Date(),
	updateUser: ``,
	updateForm: ``,

	inserted: false,
	isModified: false,
	originalData: undefined,
}